import { View } from "binder"
import { CashGatewayViewModel } from "./cashGateway-viewModel"
import { DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";

export class CashGatewayView extends View<CashGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-71C4296C-867D-46D6-B563-AAEC8FE7681A"
    }
    loadHtml(): string {
        let element = require('./cashGateway.html').default;
        let style = require('./cashGateway.less');
        return element;
    }
    constructor() {
       super();
    }
    public set district(v: DistrictSelectorViewModel) { this._district = v; } public get district(): DistrictSelectorViewModel { return this._district;} private _district: DistrictSelectorViewModel;
    
}
